/* eslint-disable react/prop-types */
import React from "react";

const CARTS_COLUMN = [
    {
        Header: "Cart ID",
        accessor: "cartId",
    },
    {
        Header: "Status",
        accessor: "status",
    },
    {
        Header: "User",
        id: "user",
        accessor: (row) => row.user?.name || row.userId,
        Cell: ({ row }) => {
            const { user, userId } = row.original;
            if (!user?.name) return userId;
            return (
                <div>
                    <div className="font-medium text-gray-800">{user.name}</div>
                    <div className="text-xs text-gray-400">{user.contactNo || userId}</div>
                </div>
            );
        },
    },
    {
        Header: "Tenant ID",
        accessor: "tenantId",
    },
    {
        Header: "Items (₹)",
        accessor: "itemsTotal",
    },
    {
        Header: "MRP (₹)",
        accessor: "mrpTotal",
    },
    {
        Header: "Savings (₹)",
        accessor: "savings",
    },
    {
        Header: "Created",
        accessor: "createdAt",
    },
];

const CART_STATUSES = ["CART_ACTIVE", "CART_LOCKED", "CART_ABANDONED", "CART_PAID"];

export { CARTS_COLUMN, CART_STATUSES };
